<template>
    <div>
        <article
            v-if="! questions.length"
            class="message is-link"
        >
            <div class="message-body">
                Loading questions...
            </div>
        </article>

        <b-steps
            v-if="questions.length"
            v-model="activeStep"
            :has-navigation="false"
        >
            <b-step-item
                v-for="(question, index) in questions"
                :key="question.LeadQuestionsPK"
                :clickable="false"
                :label="`Question ${index + 1}`"
            >
                <LeadQuestion
                    :question="question"
                    @answered="advanceStep"
                />
            </b-step-item>
        </b-steps>
    </div>
</template>

<script>
import LeadQuestion from '../../components/LeadQuestion.vue';
import { mapState, mapGetters } from 'vuex';

export default {
    components: {
        LeadQuestion,
    },

    data: function() {
        return {
            activeStep: 0,
        };
    },

    computed: {
        ...mapState('leadQuestions', [
            'questions',
        ]),
        ...mapGetters('leadQuestions', [
            'hasQuestions',
        ]),
        isLastStep: function() {
            return (this.activeStep === (this.questions.length - 1));
        },
    },

    mounted() {
        this.getQuestions();
    },

    methods: {
        getQuestions() {
            this.$store.dispatch('leadQuestions/getQuestions')
            .then(() => {
                if(! this.hasQuestions) {
                    // redirect to availability page if there are no questions
                    this.$router.push({
                        name: 'lead-availability',
                    });
                }
            })
            .catch((error) => {
                // redirect to availability page if there is an error
                this.$router.push({
                    name: 'lead-availability',
                    params: {
                        message: 'Unable to fetch questions.',
                    },
                });
            });
        },
        advanceStep() {
            if(this.isLastStep) {
                // redirect to availability page when all questions are answered
                this.$router.push({
                    name: 'lead-availability',
                });
            } else {
                // advance to next setp
                this.activeStep++;
            }
        },
    },
};
</script>
